import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";

const show = (id: number) =>
  reactQueryGet(internalApi.mediaTranscripts.show({ id }));

export const mediaTranscriptApi = {
  show,
};
